<app-audio-player></app-audio-player>
<div class="m-grid m-grid--hor m-grid--root m-page" id="portal_root">
  <!-- BEGIN: Header
  <header class="m-grid__item m-header" data-minimize-offset="200" data-minimize-mobile-offset="200">
    <app-nav></app-nav>
  </header>-->
  <!-- END: Header -->
  <!-- begin::Body -->
  <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
    <!-- BEGIN: Left Aside -->
    <button class="m-aside-left-close  m-aside-left-close--skin-light " id="m_aside_left_close_btn">
      <i class="la la-close"></i>
    </button>
    <div [hidden]="serviceCount < 2 && !hasUserManagement && !hasSiteManagement && !(serviceTypes['fundraising'] ?? false)" id="m_aside_left" class="m-grid__item	m-aside-left m-aside-left--skin-light ">
      <!-- BEGIN: Aside Menu -->
      <div id="m_ver_menu" class="m-aside-menu  m-aside-menu--skin-light m-aside-menu--submenu-skin-light "
        data-menu-vertical="true" data-menu-scrollable="false" data-menu-dropdown-timeout="500">

        <div style="width: 100%; height: 100px; background: white; z-index: 10 ;">
          <div class="logo-container">
            <img src="../../assets/app/media/img/logos/cue-logo.png"  >
          </div>
        </div>

        <ul class="m-menu__nav  m-menu__nav--dropdown-submenu-arrow">
          <br>
          <li *ngIf="serviceTypes['lightshow'] ?? false" class="m-menu__item" aria-haspopup="true" routerLinkActive="m-menu__item--active"
            [routerLinkActiveOptions]="{exact: false}">
            <a [routerLink]="['light-show']" class="m-menu__link ">
                        <i class="m-menu__link-icon flaticon-light"></i>
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">
                    LIGHT SHOWS
                  </span>
                </span>
              </span>
            </a>
          </li>
          <li *ngIf="serviceTypes['selfiecam'] ?? false" class="m-menu__item" aria-haspopup="true" routerLinkActive="m-menu__item--active"
            [routerLinkActiveOptions]="{exact: false}">
            <a [routerLink]="['selfie-cam']" class="m-menu__link ">
                        <i class="m-menu__link-icon flaticon-confetti"></i>
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">
                    SELFIE CAMS
                  </span>
                </span>
              </span>
            </a>
          </li>
          <li *ngIf="serviceTypes['triviagame'] ?? false" class="m-menu__item" aria-haspopup="true" routerLinkActive="m-menu__item--active"
            [routerLinkActiveOptions]="{exact: false}">
            <a [routerLink]="['trivia']" class="m-menu__link ">
              <i class="m-menu__link-icon flaticon-questions-circular-button"></i>
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">
                    TRIVIA GAMES
                  </span>
                </span>
              </span>
            </a>
          </li>

          <li *ngIf="serviceTypes['lightshow'] ?? false || serviceTypes['selfiecam'] ?? false || serviceTypes['triviagame'] ?? false" class="m-menu__item" aria-haspopup="true" routerLinkActive="m-menu__item--active"
          [routerLinkActiveOptions]="{exact: false}">
            <a [routerLink]="['scheduled-events']" class="m-menu__link ">
              <i class="m-menu__link-icon flaticon-calendar-3"></i>
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">
                    SCHEDULED EVENTS
                  </span>
                </span>
              </span>
            </a>
          </li>
          <li *ngIf="canEditVenues && serviceTypes['venueedit'] ?? false" class="m-menu__item" aria-haspopup="true" routerLinkActive="m-menu__item--active"
          [routerLinkActiveOptions]="{exact: false}">
            <a [routerLink]="['venue']" class="m-menu__link ">
              <i class="m-menu__link-icon flaticon-grid-menu-v2"></i>
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">
                    MY VENUES
                  </span>
                </span>
              </span>
            </a>
          </li>
          <li *ngIf="serviceTypes['coupons'] ?? false" class="m-menu__item" aria-haspopup="true" routerLinkActive="m-menu__item--active"
            [routerLinkActiveOptions]="{exact: false}">
            <a [routerLink]="['coupons']" class="m-menu__link ">
              <i class="m-menu__link-icon flaticon-gift"></i>
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">
                    COUPONS
                  </span>
                </span>
              </span>
            </a>
          </li>
          <li *ngIf="serviceTypes['upn'] ?? false" class="m-menu__item" aria-haspopup="true" routerLinkActive="m-menu__item--active"
            [routerLinkActiveOptions]="{exact: false}">
            <a [routerLink]="['upn']" class="m-menu__link ">
              <i class="m-menu__link-icon flaticon-pin"></i>
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">
                    UPN
                  </span>
                </span>
              </span>
            </a>
          </li>

          <li *ngIf="serviceTypes['genericengine'] ?? false" class="m-menu__item" aria-haspopup="true" routerLinkActive="m-menu__item--active"
            [routerLinkActiveOptions]="{exact: false}">
            <a [routerLink]="['audio-qr']" class="m-menu__link ">
              <i class="m-menu__link-icon flaticon-technology"></i>
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">
                    AUDIO QR
                  </span>
                </span>
              </span>
            </a>
          </li>

          <li *ngIf="serviceTypes['lightshow'] ?? false" class="m-menu__item" aria-haspopup="true"
            routerLinkActive="m-menu__item--active" [routerLinkActiveOptions]="{exact: false}">
            <a [routerLink]="['track-library']" class="m-menu__link ">
              <i class="m-menu__link-icon flaticon-music"></i>
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">
                    TRACK LIBRARY
                  </span>
                </span>
              </span>
            </a>
          </li>

          <li *ngIf="serviceTypes['lightshow'] ?? false" class="m-menu__item" aria-haspopup="true" routerLinkActive="m-menu__item--active"
            [routerLinkActiveOptions]="{exact: false}">
            <a [routerLink]="['toolkit']" class="m-menu__link ">
              <i class="m-menu__link-icon flaticon-cogwheel-1"></i>
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">
                    TOOLKIT
                  </span>
                </span>
              </span>
            </a>
          </li>

      <li *ngIf="serviceTypes['lightshow'] ?? false" class="m-menu__item" aria-haspopup="true"
          routerLinkActive="m-menu__item--active"
          [routerLinkActiveOptions]="{exact: false}">
        <a [routerLink]="['help']" class="m-menu__link ">
          <i class="m-menu__link-icon flaticon-information"></i>
          <span class="m-menu__link-title">
            <span class="m-menu__link-wrap">
              <span class="m-menu__link-text">
                HELP
              </span>
            </span>
          </span>
        </a>
      </li>

          <li class="m-menu__item" aria-haspopup="true" *ngIf="hasUserManagement" routerLinkActive="m-menu__item--active"
            [routerLinkActiveOptions]="{exact: false}">
            <a [routerLink]="['users']" class="m-menu__link ">
              <i class="m-menu__link-icon flaticon-users"></i>
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">
                    USER MANAGEMENT
                  </span>
                </span>
              </span>
            </a>
          </li>

          <!-- END LIVE EVENTS -->

          <!-- START CUE 5050 -->

          <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel" [routerLinkActiveOptions]="{exact: false}"  aria-haspopup="true" *ngIf="vendorId > 0 && cue5050Enabled && serviceTypes['fundraising'] ?? false" routerLinkActive="m-menu__item--active">
            <a [routerLink]="['fundraising/cue5050']" class="m-menu__link">
            <i class="m-menu__link-icon flaticon-coins"></i>
            <span class="m-menu__link-text">
              CUE 5050
            </span>
          </a>
        </li>
          <li class=" m-menu__item  m-menu__item--submenu m-menu__item--rel"  aria-haspopup="true" [routerLinkActiveOptions]="{exact: false}"  *ngIf="vendorId > 0 && vendorPermissionConditions && cue5050Enabled && routeContains('fundraising') && serviceTypes['fundraising'] ?? false" routerLinkActive="m-menu__item--active">
            <a [routerLink]="['fundraising/cue5050/event']" class="m-menu__link sub-menu-item">
            <span class="m-menu__link-text">
              Events
            </span>
          </a>
          </li>
          <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel" [routerLinkActiveOptions]="{exact: false}"  aria-haspopup="true" *ngIf="vendorId > 0 && vendorPermissionConditions && cue5050Enabled && routeContains('fundraising') && serviceTypes['fundraising'] ?? false" routerLinkActive="m-menu__item--active">
            <a [routerLink]="['fundraising/cue5050/station']" class="m-menu__link sub-menu-item">
            <span class="m-menu__link-text">
              Stations
            </span>
          </a>
          </li>
          <li class=" m-menu__item  m-menu__item--submenu m-menu__item--rel" [routerLinkActiveOptions]="{exact: false}"   aria-haspopup="true" *ngIf="vendorId > 0 && vendorPermissionConditions && cue5050Enabled  && routeContains('fundraising') && serviceTypes['fundraising'] ?? false" routerLinkActive="m-menu__item--active">
            <a [routerLink]="['fundraising/cue5050/operator']" class="m-menu__link sub-menu-item">
            <span class="m-menu__link-text">
              Operators
            </span>
          </a>
          </li>
          <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel" [routerLinkActiveOptions]="{exact: false}"  aria-haspopup="true" *ngIf="vendorId > 0 && vendorPermissionConditions && cue5050Enabled && routeContains('fundraising') && serviceTypes['fundraising'] ?? false" routerLinkActive="m-menu__item--active">
            <a [routerLink]="['fundraising/cue5050/location']" class="m-menu__link sub-menu-item">
            <span class="m-menu__link-text">
              Locations
            </span>
          </a>
          </li>
         <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel" [routerLinkActiveOptions]="{exact: false}"  aria-haspopup="true" *ngIf="vendorId > 0 && cue5050Enabled && routeContains('fundraising') && hasWebsiteCustomization && serviceTypes['fundraising'] ?? false" routerLinkActive="m-menu__item--active">
            <a [routerLink]="['fundraising/cue5050/website']" class="m-menu__link sub-menu-item">
            <span class="m-menu__link-text">
              Website Customization
            </span>
          </a>
          </li>
          <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel" [routerLinkActiveOptions]="{exact: false}"  aria-haspopup="true" *ngIf="vendorId > 0 && cue5050Enabled && routeContains('fundraising') && serviceTypes['fundraising'] ?? false" routerLinkActive="m-menu__item--active">
            <a [routerLink]="['fundraising/cue5050/tickets']" class="m-menu__link sub-menu-item">
            <span class="m-menu__link-text">
              Ticket History
            </span>
          </a>
          </li>
          <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel" [routerLinkActiveOptions]="{exact: false}"  aria-haspopup="true" *ngIf="vendorId > 0 && cue5050Enabled && routeContains('fundraising') && serviceTypes['fundraising'] ?? false" routerLinkActive="m-menu__item--active">
            <a [routerLink]="['fundraising/cue5050/reports']" class="m-menu__link sub-menu-item">
            <span class="m-menu__link-text">
              Reports
            </span>
          </a>
          </li>
          <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel" [routerLinkActiveOptions]="{exact: false}"  aria-haspopup="true" *ngIf="vendorId > 0 && cue5050Enabled && enableBarrelPrinting && routeContains('fundraising') && serviceTypes['fundraising'] ?? false" routerLinkActive="m-menu__item--active">
            <a [routerLink]="['fundraising/cue5050/printers']" class="m-menu__link sub-menu-item">
            <span class="m-menu__link-text">
              Printer Management
            </span>
          </a>
          </li>

          <!-- END CUE 5050 -->

          <div *ngIf="vendorId > 0 && ppwEnabled && cue5050Enabled && hasPledgePerWin && serviceTypes['fundraising'] ?? false">
            <br>
            <div class="border-line"></div>
            <br>
          </div>

          <!-- START PPW -->

          <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel" [routerLinkActiveOptions]="{exact: false}"  aria-haspopup="true" *ngIf="vendorId > 0 && ppwEnabled && hasPledgePerWin && serviceTypes['fundraising'] ?? false" routerLinkActive="m-menu__item--active">
            <a [routerLink]="['fundraising/ppw']" class="m-menu__link">
            <i class="m-menu__link-icon flaticon-coins"></i>
            <span class="m-menu__link-text">
              PLEDGE PER WIN
            </span>
          </a>
        </li>
          <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel" [routerLinkActiveOptions]="{exact: false}"  aria-haspopup="true" *ngIf="vendorId > 0 && ppwEnabled && routeContains('fundraising') && hasPledgePerWin && serviceTypes['fundraising'] ?? false" routerLinkActive="m-menu__item--active">
            <a [routerLink]="['fundraising/ppw/website']" class="m-menu__link sub-menu-item">
            <span class="m-menu__link-text">
              Website Customization
            </span>
          </a>
          </li>
          <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel" [routerLinkActiveOptions]="{exact: false}"  aria-haspopup="true" *ngIf="vendorId > 0 && ppwEnabled && routeContains('fundraising') && hasPledgePerWin && serviceTypes['fundraising'] ?? false" routerLinkActive="m-menu__item--active">
            <a [routerLink]="['fundraising/ppw/team']" class="m-menu__link sub-menu-item">
            <span class="m-menu__link-text">
              Teams
            </span>
          </a>
          </li>
          <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel" [routerLinkActiveOptions]="{exact: false}"  aria-haspopup="true" *ngIf="vendorId > 0 && vendorPermissionConditions && ppwEnabled && routeContains('fundraising') && hasPledgePerWin && serviceTypes['fundraising'] ?? false" routerLinkActive="m-menu__item--active">
            <a [routerLink]="['fundraising/cue5050/location']" class="m-menu__link sub-menu-item">
            <span class="m-menu__link-text">
              Locations
            </span>
          </a>
          </li>
          <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel" [routerLinkActiveOptions]="{exact: false}"  aria-haspopup="true" *ngIf="vendorId > 0 && vendorPermissionConditions && ppwEnabled && routeContains('fundraising') && hasPledgePerWin && serviceTypes['fundraising'] ?? false" routerLinkActive="m-menu__item--active">
            <a [routerLink]="['fundraising/ppw/event']" class="m-menu__link sub-menu-item">
            <span class="m-menu__link-text">
              Campaigns
            </span>
          </a>
          </li>
          <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel" [routerLinkActiveOptions]="{exact: false}"  aria-haspopup="true" *ngIf="vendorId > 0 && vendorPermissionConditions && ppwEnabled && routeContains('fundraising') && hasPledgePerWin && serviceTypes['fundraising'] ?? false" routerLinkActive="m-menu__item--active">
            <a [routerLink]="['fundraising/ppw/games']" class="m-menu__link sub-menu-item">
            <span class="m-menu__link-text">
              Games
            </span>
          </a>
          </li>
          <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel" [routerLinkActiveOptions]="{exact: false}"  aria-haspopup="true" *ngIf="vendorId > 0 && vendorPermissionConditions && ppwEnabled && routeContains('fundraising') && hasPledgePerWin && hasEngineServiceType('fundraising') | async" routerLinkActive="m-menu__item--active">
            <a [routerLink]="['fundraising/ppw/payouts']" class="m-menu__link sub-menu-item">
            <span class="m-menu__link-text">
              Payouts
            </span>
          </a>
          </li>
          <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel" [routerLinkActiveOptions]="{exact: false}"  aria-haspopup="true" *ngIf="vendorId > 0 && vendorPermissionConditions && ppwEnabled && routeContains('fundraising') && hasPledgePerWin && hasEngineServiceType('fundraising') |async" routerLinkActive="m-menu__item--active">
            <a [routerLink]="['fundraising/ppw/subscribers']" class="m-menu__link sub-menu-item">
            <span class="m-menu__link-text">
              Subscribers
            </span>
          </a>
          </li>                                                                                                                                <!-- Remove false when we're reading to show tab -->
          <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel" [routerLinkActiveOptions]="{exact: false}"  aria-haspopup="true" *ngIf="false && vendorId > 0 && ppwEnabled && routeContains('fundraising') && hasPledgePerWin && hasEngineServiceType('fundraising') |async" routerLinkActive="m-menu__item--active">
            <a [routerLink]="['fundraising/ppw/reports']" class="m-menu__link sub-menu-item">
            <span class="m-menu__link-text">
              Reports
            </span>
          </a>
          </li>


      <!-- END PPW -->

        <!-- START ADMIN -->

        <div *ngIf="hasSiteManagement">
          <br>
          <div class="border-line"></div>
          <br>
        </div>

          <li class="m-menu__item" aria-haspopup="true" *ngIf="hasSiteManagement" routerLinkActive="m-menu__item--active"
            [routerLinkActiveOptions]="{exact: false}">
            <a [routerLink]="['fundraising-admin']" class="m-menu__link ">
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <i class="m-menu__link-icon flaticon-tool-2"></i>
                  <span style="padding-left: 10px;" class="m-menu__link-text">
                    FUNDRAISING ADMIN
                  </span>
                </span>
              </span>
            </a>
          </li>

        <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"  aria-haspopup="true" *ngIf="hasSiteManagement" routerLinkActive="m-menu__item--active">
          <a [routerLink]="['fundraising-admin/merchant']" class="m-menu__link">
          <i class="m-menu__link-icon flaticon-technology-1"></i>
          <span class="m-menu__link-text">
            CHARITIES
          </span>
        </a>
        </li>

        <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"  aria-haspopup="true" *ngIf="hasSiteManagement" routerLinkActive="m-menu__item--active">
          <a [routerLink]="['fundraising-admin/vendor']" class="m-menu__link">
          <i class="m-menu__link-icon flaticon-orbit"></i>
          <span class="m-menu__link-text">
            VENDORS
          </span>
        </a>
        </li>

        <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"  aria-haspopup="true" *ngIf="hasSiteManagement" routerLinkActive="m-menu__item--active">
          <a [routerLink]="['fundraising-admin/station-app']" class="m-menu__link">
          <i class="m-menu__link-icon flaticon-interface-5"></i>
          <span class="m-menu__link-text">
            STATION APPS
          </span>
        </a>
        </li>

          <br>
          <div class="border-line" *ngIf="hasSiteManagement"></div>
          <br>

          <li class="m-menu__item" aria-haspopup="true" *ngIf="hasSiteManagement" routerLinkActive="m-menu__item--active"
            [routerLinkActiveOptions]="{exact: false}">
            <a [routerLink]="['admin']" class="m-menu__link ">
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <i class="m-menu__link-icon flaticon-tool-2"></i>
                  <span style="padding-left: 10px;" class="m-menu__link-text">
                    PORTAL MANAGEMENT
                  </span>
                </span>
              </span>
            </a>
          </li>

          <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"  aria-haspopup="true" *ngIf="hasSiteManagement" routerLinkActive="m-menu__item--active">
              <a [routerLink]="['admin/client-type']" class="m-menu__link">
              <i class="m-menu__link-icon flaticon-user-add"></i>
              <span class="m-menu__link-text">
                Client Types
              </span>
            </a>
          </li>

          <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"  aria-haspopup="true" *ngIf="hasSiteManagement" routerLinkActive="m-menu__item--active">
              <a [routerLink]="['admin/organization']" class="m-menu__link">
              <i class="m-menu__link-icon flaticon-user-settings"></i>
              <span class="m-menu__link-text">
                Organizations
              </span>
            </a>
          </li>

          <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"  aria-haspopup="true" *ngIf="hasSiteManagement" routerLinkActive="m-menu__item--active">
              <a [routerLink]="['admin/payment-history']" class="m-menu__link">
              <i class="m-menu__link-icon flaticon-piggy-bank"></i>
              <span class="m-menu__link-text">
                Purchase History
              </span>
            </a>
          </li>

          <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"  aria-haspopup="true" *ngIf="hasSiteManagement" routerLinkActive="m-menu__item--active">
              <a [routerLink]="['admin/engine']" class="m-menu__link">
              <i class="m-menu__link-icon flaticon-rocket"></i>
              <span class="m-menu__link-text">
                Engines
              </span>
            </a>
          </li>

          <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"  aria-haspopup="true" *ngIf="hasSiteManagement" routerLinkActive="m-menu__item--active">
              <a [routerLink]="['admin/engine-configs']" class="m-menu__link">
              <i class="m-menu__link-icon flaticon-interface-7"></i>
              <span class="m-menu__link-text">
                Engine Configs
              </span>
            </a>
          </li>

          <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"  aria-haspopup="true" *ngIf="hasSiteManagement" routerLinkActive="m-menu__item--active">
            <a [routerLink]="['admin/app-configs']" class="m-menu__link">
            <i class="m-menu__link-icon flaticon-interface-7"></i>
            <span class="m-menu__link-text">
              App Configs
            </span>
          </a>
        </li>

          <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"  aria-haspopup="true" *ngIf="hasSiteManagement" routerLinkActive="m-menu__item--active">
              <a [routerLink]="['admin/client-wizard']" class="m-menu__link">
              <i class="m-menu__link-icon flaticon-puzzle"></i>
              <span class="m-menu__link-text">
                Client Creation Wizard
              </span>
            </a>
          </li>

          <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"  aria-haspopup="true" *ngIf="hasSiteManagement" routerLinkActive="m-menu__item--active">
            <a [routerLink]="['admin/images']" class="m-menu__link">
            <i class="m-menu__link-icon flaticon-multimedia-1"></i>
            <span class="m-menu__link-text">
              Image Upload
            </span>
          </a>
        </li>
        <br><br>
        <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"  aria-haspopup="true" *ngIf="hasSiteManagement" routerLinkActive="m-menu__item--active">
          <a (click)="testSentry()" class="m-menu__link">
          <i class="m-menu__link-icon flaticon-cancel"></i>
          <span class="m-menu__link-text">
            Test Sentry
          </span>
        </a>
      </li>

      <!-- END ADMIN -->

          <br><br><br><br><br><br><br><br>
        </ul>
      </div> <!-- END: Aside Menu -->
    </div>
    <div>

    </div>

    <div #mainViewRef class="main-view" id="main-view" style="overflow-y: auto;">
      <!--<div style="color: #868aa8" *ngIf="router.url === '/portal'">
        <h1>Welcome to the CUE Audio Customer Portal!</h1>
        <span>Click a product from the left navigation bar to get started</span>
        <span>Need help? Check out our customer
          <a routerLink="/portal/toolkit">Toolkit!</a>
        </span>
      </div>-->
      <router-outlet></router-outlet>
     <!--<canvas
      width="1536"
      height="864"
      class="background-canvas"
      #backgroundRef>
      </canvas> -->
    </div>
  </div>

  <!-- begin::Footer -->
  <footer [style.margin-left]="'0px'" style="width: 100%"  class="m-grid__item m-footer">
    <div class="m-container m-container--fluid m-container--full-height m-page__container">
      <div class="m-stack m-stack--flex-tablet-and-mobile m-stack--ver m-stack--desktop">
        <div class="m-stack__item m-stack__item--left m-stack__item--middle m-stack__item--last">
          <span class="m-footer__copyright">
            &copy; 2021 CUE Audio, LLC
          </span>
        </div>
        <div class="m-stack__item m-stack__item--right m-stack__item--middle m-stack__item--first">
          <ul class="m-footer__nav m-nav m-nav--inline m--pull-right">
            <li class="m-nav__item">
              <a href="#" (click)="logout();" class="m-nav__link">
                <span class="m-nav__link-text">
                  Logout
                </span>
              </a>
            </li>
            <li class="m-nav__item">
              <a href="https://www.cueaudio.com/" class="m-nav__link">
                <span class="m-nav__link-text">
                  Homepage
                </span>
              </a>
            </li>
            <li class="m-nav__item">
              <a href="https://www.cueaudio.com/about-us/" class="m-nav__link">
                <span class="m-nav__link-text">
                  About
                </span>
              </a>
            </li>
            <li class="m-nav__item">
              <a href="https://cueaudio.com/privacy/" class="m-nav__link">
                <span class="m-nav__link-text">
                  Privacy
                </span>
              </a>
            </li>

            <li class="m-nav__item m-nav__item">
              <a href="mailto:support@connectwithcue.com" class="m-nav__link" data-toggle="m-tooltip" title="CUE Support"
                data-placement="left">
                <i class="m-nav__link-icon flaticon-info m--icon-font-size-lg3">
                </i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
  <!-- end::Footer -->
</div>
<div class="m-scroll-top m-scroll-top--skin-top" data-toggle="m-scroll-top" data-scroll-offset="500" data-scroll-speed="300">
  <i class="la la-arrow-up"></i>
</div>
